import _ from 'lodash';
import {Tooltip} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import {CopyIcon} from '../../../components/icons/adminIcons';
import React from 'react';
import {setSnackbar} from '../../../store/reducers/globals';
import moment from 'moment';
import config from '../../../app/config';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import {hasPermission, Permissions} from '../../../store/reducers/user';
import {PatientDetails, PatientVIPEyonixGuard} from '../../patient/patient';

const useStyles = makeStyles((theme) => ({
    advancedSearch: {
        backgroundColor: theme.palette.background.paper,
        padding: 10
    },
    root: {
        "& > *": {
            margin: theme.spacing(1),
        },
    },
    search: {
        display: "inline-flex",
        justifyContent: "center",
        width: "100%",
        backgroundColor: theme.palette.mode === "light" ? "#e3e3e3" : "#434343",
        padding: 10,
        alignItems: "center"
    },
    linksIcon: {
        position: "absolute",
        right: 15,
        top: 5
    },
    searchIcon: {
        display: "grid",
        alignItems: "center"
    },
    dialogContentStyle: {
        //  backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#ebebeb"
    },
    groupedButton: {
        border: "1px solid white",
        padding: 5,
        fontSize: 13,
        height: 36,
        minWidth: 110,
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        borderRadius: 25,
        margin: "0px 2px 0 2px",
    },
    fullName: {
        display: "inline-block",
        marginLeft: 10,
        fontWeight: 300,
    },
    familyName: {
        fontWeight: "bold",
        textTransform: "uppercase",
        marginRight: 5,
    },
    vvip: {
        color: "#e46060",
        border: "1px solid #e46060",
        padding: "3px",
        fontSize: "10px",
        marginRight: "6px",
        borderRadius: "16px",
        verticalAlign: "middle",
        display: "inline-block",
        height: "20px"
    },
    patientsTable: {
        width: "97%",
        marginLeft: "20px",
        marginTop: "20px"
    },
    topBar: {
        height: 120,
        position: "sticky",
        top: 0,
        background: theme.palette.background.paperSelected,
        zIndex: 99,
        padding: "20px 20px 10px 20px"
    },
    patientCountLabel:{
        fontSize: 14,
        marginLeft: 10
    },
    searchButtons: {
        textAlign: 'center'
    },
    tableHeader: {
        backgroundColor: theme.palette.mode === 'light' ? '#e2e2e2' : '#626466',
        padding: "5px",
        marginBottom: "7px",
        color: "white",
        fontSize: 12,
        borderRadius: 5,
        position: "sticky",
        top: "0px",
        zIndex: 9
    },
    tableRecord: {
        padding: "8px",
        marginBottom: "5px",
        backgroundColor: theme.palette.mode === 'light' ? '#cacaca' : '#4E4E4E',
        // backgroundColor: "rgb(67 67 67)",
        cursor: "pointer",
        borderRadius: 5
    },
    tableRecordSticky: {
        width: "100%",
        backgroundColor: "rgb(33, 128, 247)",
        position: "sticky",
        top: 32,
        zIndex: 6,
        marginTop: -69
    },
    pagination: {
        width: "fit-content",
        margin: "auto"
    },
    fullNameHeader: {
        marginLeft: "10px"
    },
    sortedHeader: {
        cursor: "pointer"
    },
    buttonSelector: {
        borderRadius: 50,
        backgroundColor: theme.palette.grey["300"],
        color: "rgba(0, 0, 0, 0.87)",
        margin: "0 5px",
        fontSize: 10
    },
    headerText: {
        float: "left",
        marginTop: 4
    },
    menuIcon: {
        //position: "absolute",
        // top: 10
    },
    eyonixIcon: {
        position: "absolute",
        top: 10
    },
    divRow: {
        display: "flex",
        flexWrap: "nowrap",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: "auto",
        marginRight: "auto",
    },
}));


function ListPatientsWithDocs({patientsFiltered, patientToViewStudy, patientToView, studyViewMode, searchSet}) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const {t} = useTranslation();
    const history = useHistory();

    const canViewPatientRecord = dispatch(hasPermission(Permissions.CAN_VIEW_PATIENT_RECORD));

    const patientDOB = (patient) => {
        if (patient) {
            const dob = moment(patient.dob);
            return dob.format(config.defaultDateFormat);
        }
        return "";
    };

    const patientYears = (patient) => {
        if (patient) {
            return moment().diff(moment(patient.dob), "years");
        }
        return "";
    };


    const handleCopyPtNumber = (number) => {
        if (!navigator.clipboard || !number) return;

        navigator.clipboard.writeText(number).then(() => {
            dispatch(setSnackbar({
                type: 'success',
                message: 'The patient number has been copied to the clipboard.',
            }));
        });
    };

    const openPatient = (e, patient, isSearchLock) => {
        const disableOpenPatient = e.target.closest('.disabled-options') !== null;

        if (!disableOpenPatient) {
            switch(process.env.BUILD_MODULE) {
                case "agyle":{
                    if (isSearchLock) {
                        dispatch(setSnackbar({
                            type: 'warning',
                            message: 'The patient record is restricted.',
                        }));
                    } else {

                    }
                    break;
                }
                case "main":{ ///EYONIX!!!!!
                    if(patientToViewStudy && canViewPatientRecord){
                        let id = patient.id;
                        if(searchSet) {
                            id = patient.__id
                        }

                        if(patientToView === id) patientToViewStudy(null)
                        else patientToViewStudy(id)
                    }
                    break;
                }
                default: {
                    history.push('/patient/' + patient.id);
                }
            }
        }
    };


    const getPatientRow = (patient) => {
        return <>
            <div className={classes.fullName}>
                            <span className={classes.familyName}>
                                {patient?.vip && <div className={classes.vvip}>VVIP</div>}
                                {patient.familyName}
                                {patient?.title && <span> ({patient.title})</span>}
                            </span>
            </div>

            <div>
                {patient.firstName}
            </div>

            <div>
                {patientDOB(patient)} <br/> ({patientYears(patient)} {t("years")})
            </div>


            <div className="disabled-options">
                <Tooltip title={t("Copy Patient ID")}>
                    <IconButton
                        onClick={handleCopyPtNumber.bind(this, patient?.id)}
                        size="small"
                    >
                        <CopyIcon/>
                    </IconButton>
                </Tooltip>
                {searchSet? patient.__id : patient?.id}
            </div>

            <div className="disabled-options">
                {patient?.nhsNumber &&
                <Tooltip title={t("Copy Patient NHS No")}>
                    <IconButton
                        onClick={handleCopyPtNumber.bind(this, patient?.nhsNumber)}
                        size="small"
                    >
                        <CopyIcon/>
                    </IconButton>
                </Tooltip>
                }
                {patient?.nhsNumber || 'Not provided'}
            </div>
        </>
    }

    const renderPatientsList = () => {
        let patientsList = [];

        if (!_.isEmpty(patientsFiltered)) {
            patientsList.push(
                <div key="header" className={"patients-doc-grid " + classes.tableHeader}>
                    <div className={classes.fullNameHeader + " " + classes.sortedHeader}>
                        <div className={classes.headerText}>{t("Last Name")}</div>
                    </div>
                    <div className={classes.sortedHeader}>
                        <div className={classes.headerText}>{t("First Name")}</div>
                    </div>
                    <div className={classes.sortedHeader}>
                        <div className={classes.headerText}>{t("Born")}</div>
                    </div>
                    <div className={classes.sortedHeader}>
                        <div className={classes.headerText}>{t("Hospital Number")}</div>
                    </div>
                    <div className={classes.sortedHeader}>
                        <div className={classes.headerText}>{t("MRN Number")}</div>
                    </div>
                </div>
            );

            _.forEach(patientsFiltered, (patient, index) => {
                const isSearchLock = patient?.tags?.includes('searchLocked');

                patientsList.push(
                    <div
                        key={index}
                        onClick={(e) => openPatient(e, patient, isSearchLock)}
                        className={'patients-doc-grid ' + classes.tableRecord}
                        style={(patientToView === patient.id && patientToView !== null) ?
                            {
                                background: studyViewMode === "list"? "": "rgba(33, 128, 247, 1)",
                                position: "sticky",
                                zIndex: 5
                            } :
                            {}}
                    >
                        {getPatientRow(patient)}

                    </div>
                );
                if(patientToView === (searchSet? patient.__id: patient.id) && studyViewMode === "list" && patientToView && canViewPatientRecord) {
                    patientsList.push(<div key={`${index}-studyList`} style={{marginTop: -30}}>
                     <div  className={`patients-doc-grid ${classes.tableRecord} ${classes.tableRecordSticky}`}
                           onClick={(e) => openPatient(e, patient, isSearchLock)}>
                         {getPatientRow(patient)}
                     </div>
                        <PatientVIPEyonixGuard forwardComponent={<PatientDetails patientIdOpenFromAdmin={patientToView} adminPageMode={studyViewMode}/>} patientIdOpenFromAdmin={patientToView} /></div>);
                }
            });
        } else if (patientsFiltered) {
            patientsList.push(
                <div key="nocontennt" style={{marginLeft: 10}}>
                    {t("Unfortunately we cannot find what you are looking for. Please adjust your search criteria")}
                </div>
            );
        }
        return patientsList;
    };

    return <div> {renderPatientsList()} </div>
}

export default ListPatientsWithDocs;